import { BaseDto } from '../../core';
import { PurchaseOrderShippingCreateDto, PurchaseOrderSampleProductCreateDto } from '../purchase-order';

export class CartCampaignDto extends BaseDto<CartCampaignDto> {
  cartIds: number[];
  shippingDto: PurchaseOrderShippingCreateDto;
  orderSampleProducts: PurchaseOrderSampleProductCreateDto[];
}
